<div class="sz-top-bar__row">
  <div class="sz-top-bar__brand">
    <img class="sz-top-bar__wordmark" src="assets/brand/SplitZero-wordmark-horizontal.svg" alt="SplitZero" />
  </div>

  <div class="sz-top-bar__actions">
    <sz-modules-menu />
    <sz-profile-menu />
  </div>
</div>
